export function postReactNativeCloseWebViewMessage() {
  return window.ReactNativeWebView?.postMessage('CloseWebView');
}
